// src/components/Loader/Loader.jsx
import React from "react";
import { Spin } from "antd";
import "./Loader.css";

const Loader = () => {
  return (
    <div className="loader-container">
      <Spin tip="Loading..." size="large" />
    </div>
  );
};

export default Loader;
